module.exports=function(scope){ return `${scope.fName}

<div class="g-recaptcha" style="padding-top: 10px;" data-sitekey="${scope.sitekey}" ${scope.type == 'invisible' ? `data-size="invisible" data-badge="inline"` : ''} data-callback="AssecoReCaptchaCb"></div>`};